import React, { useState, useEffect } from "react";
import { Box, keyframes } from "@mui/material";
import { SolarPower } from "@mui/icons-material";

// Define the keyframe animation
const backgroundShift = keyframes`
  0%, 100% {
    background-position: 0% 0%, 100% 0%, 50% 50%;
  }
  50% {
    background-position: 100% 100%, 0% 100%, 50% 50%;
  }
`;

export const ExamHeader = ({ currentQuestion, totalQuestions, isRecording, onTimeUp, // callback when timer finishes
  timeLeft, }) => {
  const seconds = timeLeft ?? 0;

  useEffect(() => {
    if (seconds === 0 && timeLeft !== undefined && typeof onTimeUp === "function") {
      onTimeUp();
    }
  }, [seconds, onTimeUp, timeLeft]);


  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const progress = ((currentQuestion + 1) / totalQuestions) * 100;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", borderBottom: "1px solid var(--border, #ccc)", pb: 1, mb: 2 }}>

      {/* Section with animated background */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: 2,
          borderRadius: 2,
          position: "relative",
          overflow: "hidden",
          zIndex: 0,
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "solid 1px #0191c8",
            borderRadius: 'inherit'
          },
        }}
      >
        <Box sx={{ textAlign: "center" }}>
          <Box className="hint">Question</Box>
          <Box sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
            {currentQuestion + 1} / {totalQuestions}
          </Box>
        </Box>
        <Box sx={{ textAlign: "center" }}>
          <Box
            sx={{
              fontWeight: "bold",
              fontSize: "1.2rem",
              color: isRecording ? "red" : "inherit",
            }}
          >
            {isRecording ? "Recording" : "Idle"}
          </Box>

          <Box
            sx={{
              mt: 0.5,
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            {formatTime(seconds)}
          </Box>
        </Box>
      </Box>

      {/* Progress bar */}
      <Box sx={{ width: "100%", height: "8px", background: "#eee", borderRadius: "4px", marginTop: "10px", mb: 1, mt: 2 }}>
        <Box sx={{
          width: `${progress}%`,
          height: "100%",
          background: "#0191c8",
          borderRadius: "4px",
          transition: "width 0.3s ease"
        }} />
      </Box>
    </Box>
  );
};
